module.exports = __webpack_public_path__ + "static/calendar-4c245a9af5106d05a5b4862ad2a159f2.png";